import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IMedicalTreatmentNomenclatureForAudiology } from 'gen/ApiClient';

export const MedicalTreatmentNomenclaturesCacheContext = React.createContext<ICacheContext<IMedicalTreatmentNomenclatureForAudiology[]>>(undefined as any);
